import { Spinner, UIText1, UIText2 } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

interface IShowMoreBtnProps {
  isLoading?: boolean;
  isError?: boolean;
  disabled?: boolean;
  onClick(): void;
}

export const ShowMoreBtn: React.VFC<IShowMoreBtnProps> = ({ isLoading, onClick, disabled, isError }) => {
  if (isError) {
    return <UIText2 color="error_100">Что-то пошло не так. Попробуйте позже</UIText2>;
  }

  return (
    <button
      className={cn(styles['button'], disabled && !isLoading && styles['disabled'])}
      onClick={() => onClick()}
      disabled={disabled}
      data-name="estimations_history_more"
    >
      {isLoading ? (
        <Spinner size={16} data-name="estimations_loading" />
      ) : (
        <UIText1 color="primary_100" fontWeight="bold">
          Загрузить ещё
        </UIText1>
      )}
    </button>
  );
};
